import { Flex } from '@radix-ui/themes'
import { InfoIcon, StarIcon } from 'lucide-react'

import { NOTE, STEPS } from './content'

import type { ChileautosHighlightsStep } from './journey'

/*
Las piezas del texto que comparten la versión de escritorio y la de teléfono.
Cambia el tamaño de la letra, no lo que dicen.
*/

export const Kicker = () => (
  <Flex align="center" gap="2" className="mb-2 text-[#e5484d]">
    <StarIcon size={16} />
    <span className="font-mono text-[10px] font-bold uppercase tracking-wider">Publicaciones · ChileAutos</span>
  </Flex>
)

export const Headline = ({ className = '' }: { className?: string }) => (
  <p className={`font-bold leading-snug text-[#1c1917] [text-wrap:balance] ${className}`}>
    Destaca tus avisos de ChileAutos sin salir de Veekls
  </p>
)

interface StepListProps {
  active: ChileautosHighlightsStep
  /** Phone text runs a size larger: it is read at arm's length, not at a desk. */
  size: 'wide' | 'phone'
}

export const StepList = ({ active, size }: StepListProps) => {
  const text = size === 'phone' ? 'text-[12.5px]' : 'text-[11px]'
  const title = size === 'phone' ? 'text-[13px]' : 'text-[11px]'

  return (
    <div className="space-y-1.5">
      {STEPS.map((step) => (
        <div
          key={step.number}
          className="vk-info-block rounded-r py-2 pl-2.5 pr-2"
          data-tone="red"
          data-active={active === step.number}
        >
          <Flex align="start" gap="2">
            <span className="vk-step-num mt-0.5">{step.number}</span>
            <div>
              <p className={`${title} font-bold leading-tight text-[#1c1917]`}>
                {step.title}
                {step.first && (
                  <span className="ml-1.5 rounded bg-[#e5484d] px-1 py-0.5 align-middle font-mono text-[8px] font-bold uppercase text-white">
                    Primero
                  </span>
                )}
              </p>
              <p className={`${text} mt-0.5 leading-snug text-[#706d71]`}>{step.text}</p>
            </div>
          </Flex>
        </div>
      ))}
    </div>
  )
}

export const Note = ({ size }: { size: 'wide' | 'phone' }) => (
  <Flex align="start" gap="2" className="rounded-lg border border-[#e4e1e4] bg-[#faf8f8] p-2.5">
    <InfoIcon size={14} className="mt-0.5 shrink-0 text-[#706d71]" />
    <p className={`${size === 'phone' ? 'text-[12px]' : 'text-[11px]'} leading-snug text-[#706d71]`}>{NOTE}</p>
  </Flex>
)
